module.exports = __webpack_public_path__ + "img/img1_4.d1ba54cb.jpeg";